module.exports = __webpack_public_path__ + "img/experiences_K Kids run the bases.e69ff86c.jpg";